/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkDeleteFacilityServiceAreasResponse
 */
export interface BulkDeleteFacilityServiceAreasResponse {
    /**
     * 
     */
    deleted: number;
}

/**
 * Check if a given object implements the BulkDeleteFacilityServiceAreasResponse interface.
 */
export function instanceOfBulkDeleteFacilityServiceAreasResponse(value: object): value is BulkDeleteFacilityServiceAreasResponse {
    if (!('deleted' in value) || value['deleted'] === undefined) return false;
    return true;
}

export function BulkDeleteFacilityServiceAreasResponseFromJSON(json: any): BulkDeleteFacilityServiceAreasResponse {
    return BulkDeleteFacilityServiceAreasResponseFromJSONTyped(json, false);
}

export function BulkDeleteFacilityServiceAreasResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkDeleteFacilityServiceAreasResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'deleted': json['deleted'],
    };
}

export function BulkDeleteFacilityServiceAreasResponseToJSON(json: any): BulkDeleteFacilityServiceAreasResponse {
    return BulkDeleteFacilityServiceAreasResponseToJSONTyped(json, false);
}

export function BulkDeleteFacilityServiceAreasResponseToJSONTyped(value?: BulkDeleteFacilityServiceAreasResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deleted': value['deleted'],
    };
}

